import React from 'react';
import PropTypes from 'prop-types';
import { Slider as AntSlider } from 'antd';
import './Slider.scss';
import classnames from 'classnames';
import { commafy } from 'helpers/number';
import { SLIDER_COLOR_BLUE100 } from 'types/slider.constants.js';
import { useAddAccesibilityAttributes } from 'hook/helper.hook';

function Slider({
  datatestid,
  label = true,
  step,
  min,
  max,
  value,
  onChange,
  disabled,
  onAfterChange,
  className,
  size,
  sliderLabelClass,
  trackStyle,
  fullWidth,
  ...props
}) {
  const sizeClass = size === 'big' ? 'bigSliderHandle' : 'normalSliderHandle';
  const finalClassName = className != null ? className : '';
  let finalTrackingStyle = {
    backgroundColor: SLIDER_COLOR_BLUE100,
    // Oerriding in the class style cause color change on hover state without using !important.
    // !important override prevent us to override color in consumer component.
  };
  if (trackStyle) {
    finalTrackingStyle = {
      ...finalTrackingStyle,
      ...trackStyle,
    };
  }

  const widthClass = fullWidth ? 'format100' : 'format50';

  useAddAccesibilityAttributes('.ant-slider-handle', [
    {
      attribute: 'name',
      value: 'slider',
    },
    {
      attribute: 'id',
      value: 'slider',
    },
    {
      attribute: 'aria-label',
      value: 'slider',
    },
  ]);

  return (
    <div
      className={classnames(
        widthClass,
        'slider-container FlexContainer flex-column',
      )}
    >
      <AntSlider
        data-testid={datatestid ? `${datatestid}-input` : null}
        step={step}
        min={min}
        max={max}
        tipFormatter={null}
        value={value ? value : min}
        onChange={e => {
          if (onChange) {
            onChange(e);
          }
        }}
        onAfterChange={e => {
          if (onAfterChange) {
            onAfterChange(e);
          }
        }}
        disabled={disabled}
        className={`${finalClassName} ${sizeClass}`}
        trackStyle={finalTrackingStyle}
        {...props}
        handleStyle={[
          {
            boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)',
            outline: 'none',
          },
        ]}
      />
      {label ? (
        <div className="FlexContainer justify-between">
          <div
            data-testid={datatestid ? `${datatestid}-left-label` : null}
            className={classnames(sliderLabelClass, 'slider-left-label')}
          >
            ${commafy(min)}
          </div>
          <div
            data-testid={datatestid ? `${datatestid}-right-label` : null}
            className={classnames(sliderLabelClass, 'slider-right-label')}
          >
            ${commafy(max)}
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

Slider.defaultProps = {
  disabled: false,
  min: 0,
  max: 100,
};

Slider.propTypes = {
  step: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.number,
  disabled: PropTypes.bool,
  datatestid: PropTypes.string,
};

export { Slider };
